import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TopTenCustomersDashboardService{

  
  constructor(private apiService:ApiService) { }


 getTopTenCustomers(queryParams: HttpParams) {
  return this.apiService.get('invoice/top-ten-customers', queryParams);
}
  

}
